import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/NewTitle";

export const SolutionCustomer = ({
  customTitle = null,
  customSubTitle = null,
}) => {
  const { t } = useTranslation();
  const logoList = [
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-zhihu.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-toyota.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-beijing.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-udemy.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-zhaoshang.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-xiangong.png",
      alt: `authing treelab`,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-gaojiaoshe.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-yikuaibao.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-binli.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-csdn.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/home-logo-pingcap.png",
      alt: `authing`,
    },

    {
      imgurl: "//files.authing.co/authing-website/customer-logo-chunhui.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-nreal.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-xrspace.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-yuanqi.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-haidilao.png",
      alt: `authing `,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-cxmt.png",
      alt: `authing `,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-sanxing.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-yunnan.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-cola.png",
      alt: `authing `,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-kerui.png",
      alt: `authing`,
    },
    {
      imgurl: "//files.authing.co/authing-website/customer-logo-fuxin.png",
      alt: `authing`,
    },

    {
      imgurl: "//files.authing.co/authing-website/customer-logo-guangda.png",
      alt: `authing`,
    },

    {
      imgurl: "//files.authing.co/authing-website/customer-logo-tianzhu.png",
      alt: `authing`,
    },
  ];
  return (
    <section>
      <div className="customer-brand">
        <div className="inner">
          {customTitle ? (
            <Title title={customTitle}>{customSubTitle}</Title>
          ) : (
            <Title title={t("solution.list.customer.title")}></Title>
          )}

          <div className="card-warp">
            {logoList.map((item, index) => {
              return (
                <div className="card" key={index}>
                  <img src={item.imgurl} alt={item.alt} />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
